import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Program } from '../../../../../types/types';
import ProgramDetails from './ProgramDetails';
import CurrentUserGoals from '../currentUserGoals/CurrentUserGoals';

interface ProgramInformationsProps {
  program: Program;
  onSaveProgramName: (id: string, newName: string) => void;
}

const ProgramInformations: React.FC<ProgramInformationsProps> = ({ program, onSaveProgramName }) => {
  const { t } = useTranslation('global');
  const [programName, setProgramName] = useState(program.programName);
  const [assignedClientId, setAssignedClientId] = useState<string | null>(null);

  useEffect(() => {
    setProgramName(program.programName);
  }, [program.programName]);



  return (
    <>
      <ProgramDetails programId={program.id} onAssignedClientChange={setAssignedClientId} />
      {assignedClientId && (<CurrentUserGoals clientId={assignedClientId} />)}
    </>

  );
};

export default ProgramInformations;
